import type { ReactNode } from 'react';

import { AuthLayout, Card } from '@keboola/design';
import { ArrowLeft } from '@keboola/design/icons';

import { AppWordmark } from './AppWordmark';
import { ColorSchemeMenu } from './ColorSchemeMenu';
import { TextLink } from './TextLink';

/**
 * App-specific chrome for the auth screens on top of `AuthLayout`: lockup, scheme control, way out.
 *
 * - Not `@keboola/auth`: its `SignIn` has a stack picker, meaningless for apps-api (one Cognito pool).
 */
export function AuthChrome({ children }: { children: ReactNode }) {
  return (
    <AuthLayout>
      {/* - `size="auth"`: no bar here, so the lockup alone names the product.
          - Scheme control is available before sign-in, inside the `header` landmark. */}
      <AuthLayout.Header actions={<ColorSchemeMenu />}>
        <AppWordmark size="auth" />
      </AuthLayout.Header>

      <AuthLayout.Content>
        <Card>
          <Card.Content>{children}</Card.Content>
        </Card>
      </AuthLayout.Content>

      {/* The public catalog is reachable without signing in.
          - `/components`, not `/`: users bounce here from a component page.
          - ⚠️ `TextLink`, not muted text: muted on `bg-muted` is 4.34:1, under AA. */}
      <AuthLayout.Footer>
        <TextLink
          to="/components"
          className="tw:flex tw:items-center tw:justify-center tw:gap-1.5 tw:text-sm"
        >
          <ArrowLeft className="tw:size-4" aria-hidden="true" />
          Back to the component catalog
        </TextLink>
      </AuthLayout.Footer>
    </AuthLayout>
  );
}
